<template>
  <table class="striped admin-organizations-table">
    <caption v-html="caption" v-if="caption" />
    <thead>
      <tr>
        <th>Organization</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="organization in paginatedOrganizations"
        :key="organization.id"
        :class="selectedId === organization.id ? 'selected' : 'selectable'"
        @click="handleSelect(organization)"
      >
        <td>{{ organization.name }}</td>
      </tr>
      <tr v-if="organizations.length === 0">
        <td class="no-records">
          There are currently no organizations in the system.
        </td>
      </tr>
    </tbody>
    <tfoot v-if="hasPages">
      <tr>
        <td class="page-controls" colspan="2">
          <icon-button
            :disabled="!hasPrevPage"
            name="prev"
            @click="goToPrevPage"
          />

          <icon-button
            :disabled="!hasNextPage"
            name="next"
            @click="goToNextPage"
          />
        </td>
      </tr>
    </tfoot>
  </table>
</template>

<script>
import { pagination } from "../../mixins/pagination";

export default {
  mixins: [pagination("organizations")],

  props: {
    caption: {
      type: String,
      default: undefined,
    },
    organizations: {
      type: Array,
    },
    selectedId: {
      type: Number,
      default: -1,
    },
  },

  methods: {
    handleSelect(organization) {
      this.$emit("select", organization);
    },
  },
};
</script>